import { sqAxiosStore } from '@/core/core.stores';

export const addRequest = (id: string) => sqAxiosStore.addRequest(id);

export const removeRequest = (id: string) => sqAxiosStore.removeRequest(id);
